/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import useAppDispatch from "common/hooks/useAppDispatch";
import { dequeueNotification, enqueueNotification } from "store/slices/notification";
import { NotificationProps } from "common/types/Notification";

export default function useNotification() {
    const dispatch = useAppDispatch();
    return {
        dequeueNotification: (notificationMessage?: string) => dispatch(dequeueNotification(notificationMessage)),
        enqueueNotification: (notification: NotificationProps) => dispatch(enqueueNotification(notification)),
    };
}
